$( document ).ready(function() {
  $('.custom-faq-related-content[data-heading-name!="category_1"]').hide();
  $($('[data-heading-name="category_1"]')[1]).addClass('c2-custom-border-top');
  $($('[data-heading-name="category_1"]')[$('[data-heading-name="category_1"]').length-1]).addClass('c2-custom-border-bottom');
});
  
$(document).on("click",".custom-faq-related-heading-content",function() {
  $('.custom-faq-related-heading-content.active').removeClass('active'); 
  $(this).addClass('active');

   
  var faq_type=$(this).data('heading-name');
  $('.custom-faq-related-content').hide(); 
  $('.custom-faq-related-content[data-heading-name="'+faq_type+'"]').show();
  $('.custom-faq-related-content').removeClass('c2-custom-border-top'); 
  $('.custom-faq-related-content').removeClass('c2-custom-border-bottom');
  $($('[data-heading-name="'+faq_type+'"]')[1]).addClass('c2-custom-border-top');
  $($('[data-heading-name="'+faq_type+'"]')[$('[data-heading-name="'+faq_type+'"]').length-1]).addClass('c2-custom-border-bottom');
  $('.custom-faq-content1 h3').text($(this).text().trim());
  
});
 


$(document).on("click",".custom-faq-related-content",function() {
  if($(this).hasClass('active')){
  	$(this).removeClass('active');
  }else{
	$(this).addClass('active'); 
  } 
}); 

 


$(document).ready(function () {
    // Get the default sort-by value
    let defaultSort = $('#sort-by').data('default-sort');

    // Set active class based on the current sort and update text
    $('.sortingBtnNew').each(function () {
        if ($(this).data('val') === defaultSort) { 
            $('.sortingBtnNew').removeClass('activeSort');
            $(this).addClass('activeSort');

            // Set initial Sort By text 
            $('.filter_text.dropDownBtn').text($(this).text());
        }  
    });
 
    // Handle button click event
    $('.sortingBtnNew').click(function () { 
        let selectedSort = $(this).data('val');

        // Update active class  
        $('.sortingBtnNew').removeClass('activeSort');
        $(this).addClass('activeSort'); 

        // Update the sort-by dropdown value
        $('#sort-by').val(selectedSort).trigger('change'); 

        // Update the Sort By text
        $('.filter_text.dropDownBtn').text($(this).text());
    });

    // Sync select change (in case it's updated manually)
    $('#sort-by').change(function () {
        let selectedSort = $(this).val();  

        // Update active class in custom dropdown
        $('.sortingBtnNew').removeClass('activeSort'); 
        $('.sortingBtnNew[data-val="' + selectedSort + '"]').addClass('activeSort');

        // Update the Sort By text
        let selectedText = $('.sortingBtnNew[data-val="' + selectedSort + '"]').text();
        $('.filter_text.dropDownBtn').text(selectedText);      

        // Perform sorting (Shopify handles sorting via URL parameters)  
        let url = new URL(window.location.href);
        url.searchParams.set('sort_by', selectedSort); 
        window.location.href = url.toString();    
    });
});

$(".dropDownBtn").click(function () {
  $(this).parent(".filterCustomDropDown").toggleClass("activeDropDown"); 
});


  $(".sortingBtnNew").click(function () { 
    let dataVal = $(this).attr("data-val"); 
    let thisText = $(this).text(); 
    $("#sort-by").val(dataVal).trigger("change"); 
    $(".sortingBtnNew").removeClass("activeSort");
    $(this).addClass("activeSort");
    $(".filterCustomDropDown").removeClass("activeDropDown");

    $(this)
      .parent(".dropDownItem")
      .prev(".dropDownBtn")
      .children(".btnTxt")  
      .text(thisText);
  });



$(document).ready(function() {
  // Toggle filter form on button click
  $('.collection__tag-filter-btn').on('click', function(e) {
    e.stopPropagation(); // Prevent click from reaching document
    $('.c2-slider-faceted-filter-form').show(); 
    $(this).addClass('active');
  });

  // Prevent clicks inside the form from closing it
  $('.c2-slider-faceted-filter-form').on('click', function(e) {
    e.stopPropagation();
  });

  // Click anywhere else: close the form
  $(document).on('click', function() {
    $('.c2-slider-faceted-filter-form').hide();
    $('.collection__tag-filter-btn').removeClass('active');
  });
});


$(document).ready(function () {
  $('.sidebar-block__heading').on('click', function () {
    const $content = $(this).closest('.sidebar__block').find('.sidebar-block__content');
    const $icon = $(this).find('.sidebar-block__icon');

    $content.slideToggle(300, function () {
      $icon.toggleClass('is-open');
      $icon.text($icon.hasClass('is-open') ? '-' : '+');
    });
  }); 
});
 


$(document).ready(function() {
  // Open the first FAQ answer globally
  $('.faq__item-answer').first().show();
  $('.faq__item').first().addClass('active');
});
 



$(document).on("click",".menu__heading", ".filter-btn", function(){
  $(this).parent().toggleClass("menu-open");
}); 







 if ($(window).width() <= 768) {
    $('.c2_collist .featured-collection').flickity({
         contain: true, 
        cellAlign: 'left',
        pageDots: false,
        wrapAround: true,
        groupCells: true,
        freeScroll: true, 
        prevNextButtons: true,
         
     }); 
}

    if ($(window).width() <= 768) {
    $('.collections-container').flickity({
        contain: true, 
        cellAlign: 'left',
        pageDots: false,
        wrapAround: true,
        groupCells: true,
        freeScroll: true,  
        prevNextButtons: false,
         
     }); 
}

 

 if ($(window).width() <= 768) {
    $('.blog-posts .blog-content').flickity({
         contain: true, 
        cellAlign: 'left',
        pageDots: false,
        wrapAround: true,
        groupCells: true,
        freeScroll: true, 
        prevNextButtons: false,
         
     });
}




if ($(window).width() <= 768) {
    $('.c2-list-collection .main-list-col').flickity({
         contain: true, 
        cellAlign: 'left',
        pageDots: false,
        wrapAround: true,
        groupCells: true,
        freeScroll: true, 
        prevNextButtons: false, 
         
     });
}


$(document).ready(function() {
  $('.mobile-menu__first-level.has-submenu').click(function(e) {

    // Remove active class from all submenus
    $('.mobile-submenu__list').removeClass('active');

    // Add active class to the clicked one
    $(this).find('.mobile-submenu__list').addClass('active'); 
  });

  // Back button click to remove active class
  $(document).on('click', '.c2-mobile-menu-heading-back', function(e) {
    e.preventDefault();
    console.log("Back clicked"); // Check console
    $(this).closest('.mobile-submenu__list').removeClass('active');
  });
});
 
 
if ($(window).width() <= 768) {
// Footer Menu Heading Click Event
$(document).on("click", ".footer__menu .footer__heading", function () {
  var $parent = $(this).parent();
  var $content = $parent.find('ul'); // Assuming the content to slide is a <ul> inside the parent

  if ($parent.hasClass("menu-open")) {
    $content.stop(true, true).slideUp(300, function () {
      $parent.removeClass("menu-open");
    });
  } else {
    $(".footer__menu.menu-open").each(function () {
      var $otherParent = $(this);
      $otherParent.removeClass("menu-open");
      $otherParent.find('ul').stop(true, true).slideUp(300);
    });

    $content.css('display', 'none'); // Ensure initial state is hidden
    $parent.addClass("menu-open");
    $content.stop(true, true).slideDown(500);
  }
});

// Default open the first menu on page load
$(document).ready(function () {
  var $firstMenu = $(".footer__menu").first();
  var $content = $firstMenu.find('ul');

  $firstMenu.addClass("menu-open");
  $content.stop(true, true).slideDown(0); // Show instantly on load
});


}
 
document.addEventListener('DOMContentLoaded', function () {
  const playButtons = document.querySelectorAll('[data-play-button]'); 

  playButtons.forEach(button => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('[data-video-wrapper]');
      if (!wrapper) return;

      // YouTube iframe
      const iframe = wrapper.querySelector('iframe');
      if (iframe && iframe.src.includes('youtube')) { 
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'playVideo' }),
          '*'
        );
      }

      // HTML5 video
      const html5Video = wrapper.querySelector('video');
      if (html5Video) {
        html5Video.play();
      }

      // Hide placeholder image and play button
      const imageWrapper = document.querySelector('[data-image-element]');
      if (imageWrapper) {
        imageWrapper.style.display = 'none';
      }

      button.style.display = 'none';
    });
  }); 
});



  document.addEventListener("DOMContentLoaded", function () {
    const headings = document.querySelectorAll(".sidebar-block__heading");   

    headings.forEach((heading) => {
      heading.addEventListener("click", function () {
        heading.classList.toggle("is-open");
      });
    }); 
  });



 

// Add to cart 
  $(document).on('click', '.cart_btn', function(e) {
    e.preventDefault();

    var $container = $(this).closest('.c2_custom_form_upsell');
    var variantId = $container.find('.variant-dropdown').val();

    console.log("Variant ID selected:", variantId); // ✅ log it

    if (!variantId) {
      variantId = $container.find('.cart_btn').attr('data-product-id');
      // alert("Please select a variant.");
      // return;
    }

    $container.addClass('ev-adding');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: variantId
      },
      dataType: 'json',
      success: function(cart) {
        console.log("Added to cart:", cart); // ✅ log cart
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        var scrollTopValue = $('.ajax-cart__product').eq(0).offset().top;
        $('.ajax_cart_main').animate({ scrollTop: scrollTopValue }, 'slow');

        $('.ev-adding').removeClass('ev-adding');
      },
      error: function(error) {
        console.error("Add to cart error:", error); // ✅ log error
        var $errorMsg = "<p class='error_msg'>" + error.responseJSON.message + "</p>";

        if ($container.find('.error_msg').length) {
          $container.find('.error_msg').text(error.responseJSON.message);
        } else {
          $container.append($errorMsg);
        }

        setTimeout(function () {
          $container.find('.error_msg').remove();
          $container.removeClass('ev-adding');
        }, 1500);
      }
    });
  });





 

$(document).ready(function() { 
  // Load hidden products from localStorage
  const hiddenProducts = JSON.parse(localStorage.getItem('hiddenProducts')) || [];

  // Hide products that were previously added
  $('.cart_btn').each(function() {
    const productId = $(this).data('product-id').toString();
    if (hiddenProducts.includes(productId)) {
      $(this).closest('.product').hide();
    }
  });

  // Add product to hidden list on click
  $('.cart_btn').on('click', function() {
    const productId = $(this).data('product-id').toString();

    // Add to hidden products list
    if (!hiddenProducts.includes(productId)) {
      hiddenProducts.push(productId);
      localStorage.setItem('hiddenProducts', JSON.stringify(hiddenProducts));

      // Hide the product instantly
      $(this).closest('.product').hide();
    }
  });
});  

